import React from 'react';
import Modal from "../common/Modal/Modal";

function Intro({show = false, onClose , content }) {
    return <Modal
        size='small'
        show={show}
        onClose={onClose}
    >
        <div dangerouslySetInnerHTML={{__html: content}} />

        
    </Modal>
}

export default Intro;
